import { Position } from './Position';

export class RelativePosition {
    constructor(
        private maxRadius: number,
        private centerPosition: Position,
        private threatLevel: number,
        private angle: number
    ) {}

    public position(): Position {
        return new Position(
            this.centerPosition.x + Math.cos(-this.angle) * this.ratio(this.threatLevel), // minus angle because the y axis is going downward in HTML canvas
            this.centerPosition.y + Math.sin(-this.angle) * this.ratio(this.threatLevel)
        );
    }

    private ratio(threatLevel: number) : number {
        const numCount = 6;
        const numSpacing = this.maxRadius / numCount;
        const maxThreatLevel = 16;
        const minThreatLevel = 0.0625;
        // (x - min) / (max - min)
        const boundedThreatLevel = ((threatLevel - minThreatLevel) / (maxThreatLevel - minThreatLevel)) * numCount;
        return this.maxRadius - (boundedThreatLevel * numSpacing);
    }
} 